import {
  Children, cloneElement, ReactElement,
} from 'react';

import './SwipeableList.scss';

type Props = {
  children?: ReactElement | ReactElement[];
  scrollStartThreshold?: number;
  swipeStartThreshold?: number;
  threshold?: number;
};

const SwipeableList = ({
  children, scrollStartThreshold, swipeStartThreshold, threshold,
}: Props): JSX.Element => (
  <div className="swipeable-list" data-testid="list-wrapper">
    {children
            && Children.map(children, (child: ReactElement) => cloneElement(child, {
              scrollStartThreshold,
              swipeStartThreshold,
              threshold,
            }))}
  </div>
);

export default SwipeableList;
